import { render, staticRenderFns } from "./CreatCardMenu.vue?vue&type=template&id=36f252ed&scoped=true&"
import script from "./CreatCardMenu.vue?vue&type=script&lang=js&"
export * from "./CreatCardMenu.vue?vue&type=script&lang=js&"
import style0 from "./CreatCardMenu.vue?vue&type=style&index=0&id=36f252ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f252ed",
  null
  
)

export default component.exports